import state from './socket.state'
import mutations from './socket.mutations'
import actions from './socket.actions'

export default {
  state,
  mutations,
  actions
}
